import { gql } from "shared/lib/graphql"

export type CreditsBalanceStatus = "ok" | "moderate" | "low" | "very_low" | "empty"

export interface CreditsBalance {
  remaining: number
  monthly_total: number
  spent: number
  reset_date: string
  status: CreditsBalanceStatus
}

export const CreditsBalanceFields = gql`
  remaining
  monthly_total
  spent
  reset_date
  status
`
